import React, { useEffect, useState } from 'react';
import { DetailModal } from '../../../components';
import { DiseaseTabs } from './DiseaseTabs';
var DiseaseModal = function (_a) {
    var disease = _a.disease, show = _a.show, onHide = _a.onHide, diseaseModalExposure = _a.diseaseModalExposure, diseaseTabClickReport = _a.diseaseTabClickReport;
    var _b = useState('overview'), diseaseTab = _b[0], setDiseaseTab = _b[1];
    var onChangeDiseaseTab = function (val) {
        setDiseaseTab(val);
    };
    useEffect(function () {
        if (show) {
            diseaseModalExposure(diseaseTab);
        }
    }, [show]);
    return (React.createElement(DetailModal, { title: disease.name, show: show, onHide: onHide, height: '50%' },
        React.createElement(DiseaseTabs, { disease: disease, type: "modal", style: { height: '100%' }, currentTab: diseaseTab, onChange: onChangeDiseaseTab, diseaseTabClickReport: diseaseTabClickReport })));
};
export default DiseaseModal;
